export default {
    index: {
        listagem_faixa_resultado: 'Result Range Listing',
        faixa_resultado_nao_encontrada: 'No result range found',
        criar_faixa_resultado: 'Create Result Range',
        origem: 'Origin',
        destino: 'Destiny',
        exame: 'Exam',
        editar: 'Edit'
    },
    form: {
        integracao_origem: 'Origin Integration',
        integracao_destino: 'Destiny Integration',
        exame: 'Exam',
        condicoes: 'Conditions',
        salvar: 'Save',
        status_descricao: 'Result Conversion Status',
        titulo_editar: 'Edit Result Conversion',
        titulo_criar: 'Create New Result Conversion',
        integracao_origem_obrigatoria: 'Origin integration selection is mandatory!',
        integracao_destino_obrigatoria: 'Destiny integration selection is mandatory!',
        exame_obrigatorio: 'Exam selection is mandatory!',
        criada_sucesso: 'Result range configuration successfully created',
        editada_sucesso: 'Result range configuration successfully updated'
    }
}